export default __webpack_public_path__ + "static/media/faq_flower_2.43ca8952.webp";